import { render } from "./SliderApp.vue?vue&type=template&id=55f21f7e&scoped=true&lang=true"
import script from "./SliderApp.vue?vue&type=script&lang=js"
export * from "./SliderApp.vue?vue&type=script&lang=js"

import "./SliderApp.vue?vue&type=style&index=0&id=55f21f7e&lang=scss&scoped=true"

import exportComponent from "/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55f21f7e"]])

export default __exports__